var React = require('react');

function IconTravelAlt (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"m111.28 63.41h-59.28a2.72 2.72 0 0 0 -2.72 2.72v38a2.72 2.72 0 0 0 2.72 2.74h59.29a2.72 2.72 0 0 0 2.72-2.72v-38a2.72 2.72 0 0 0 -2.73-2.74zm-28.28 27.07-12.4-12.37 1.4-6.65 6.64-1.41 12.36 12.38z","key":0}),React.createElement("path",{"d":"m95.45 63.41v-4.17a6.89 6.89 0 0 0 -6.87-6.88h-13.88a6.88 6.88 0 0 0 -6.87 6.88v4.17","key":1}),React.createElement("path",{"d":"m48.38 53.58 5 9.83h9.64l-4.08-20.41 15.06-15a4 4 0 1 0 -5.65-5.65l-15.07 15.02-36.14-7.31-3.14 3.15 28.72 14.72-14.72 14.71-7.77-1.57-3.14 3.14 9.91 5.08 5.1 9.91 3.14-3.15-1.57-7.76z","key":2})]);
}

IconTravelAlt.defaultProps = {"viewBox":"0 0 128 128"};

module.exports = IconTravelAlt;

IconTravelAlt.default = IconTravelAlt;
